import { render, staticRenderFns } from "./form.vue?vue&type=template&id=df72c092&"
import script from "./form.vue?vue&type=script&lang=js&"
export * from "./form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kasingkhoo/NestJsProjects/ivm_web_ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df72c092')) {
      api.createRecord('df72c092', component.options)
    } else {
      api.reload('df72c092', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=df72c092&", function () {
      api.rerender('df72c092', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mvms/components/form.vue"
export default component.exports